"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const client_1 = require("react-dom/client");
const client_2 = require("@apollo/client");
const nice_modal_react_1 = __importDefault(require("@ebay/nice-modal-react"));
const react_favicon_1 = __importDefault(require("react-favicon"));
const en_json_1 = __importDefault(require("@shopify/polaris/locales/en.json"));
const polaris_1 = require("@shopify/polaris");
const queryDefinitions_1 = require("./queryDefinitions");
const Root_1 = __importDefault(require("./Root"));
const AccountContext_1 = require("./contexts/AccountContext");
const context_1 = require("@/common/context");
const layout_1 = require("@/common/components/layout");
const apolloClient_1 = require("./apolloClient");
const useLogout_1 = require("hooks/useLogout");
const favicon_32x32_png_1 = __importDefault(require("./assets/images/favicon-32x32.png"));
require("./assets/styles/base.css");
require("./assets/styles/reset.css");
require("@shopify/polaris/build/esm/styles.css");
const RootWithApollo = () => {
    const { data: loginData } = (0, client_2.useQuery)(queryDefinitions_1.IS_LOGGED_IN);
    const handleLogout = (0, useLogout_1.useLogout)();
    return react_1.default.createElement(Root_1.default, { isLoggedIn: loginData.isLoggedIn, onLogout: handleLogout });
};
const rootElement = document.querySelector('#root');
if (rootElement) {
    const root = (0, client_1.createRoot)(rootElement);
    root.render(react_1.default.createElement(AccountContext_1.AccountProvider, null,
        react_1.default.createElement(client_2.ApolloProvider, { client: apolloClient_1.apolloClient },
            react_1.default.createElement(context_1.CurrentUserProvider, null,
                react_1.default.createElement(polaris_1.AppProvider, { i18n: en_json_1.default, linkComponent: layout_1.PolarisNavLink },
                    react_1.default.createElement(nice_modal_react_1.default.Provider, null,
                        react_1.default.createElement(react_favicon_1.default, { url: favicon_32x32_png_1.default }),
                        react_1.default.createElement(RootWithApollo, null)))))));
}
